/**
 * åç«¯çæ¬ç±»åæä¸¾ï¼å¯æå±ï¼
 */
export enum VersionType {
  LITE = 'LITE',
  FORMAL = 'FORMAL'
}



